import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Error } from "@bw/forms"
import { breakpoints } from "../../../theme"

const Wrapper = styled.div`
  margin-bottom: 25px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const Asterisk = styled.span`
  &:before {
    content: "*";
    margin-left: 0.3em;
    color: red;
  }
`

const Label = styled.label`
  display: block;
  font-family: "Ginto", georgia, serif;
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  line-height: 152.9%;
  letter-spacing: 0.025em;
  margin-bottom: 0.3em;

  @media (min-width: ${breakpoints.medium}px) {
    font-size: 15px;
  }
`

const FormField = ({ children, ...props }) => {
  return (
    <Wrapper>
      <Label htmlFor={props.name}>
        {props.title}
        {props.required && <Asterisk />}
      </Label>
      {props.help && props.helpPosition === "above" && (
        <small>{props.help}</small>
      )}
      {children}
      {props.help && props.helpPosition === "below" && (
        <small>{props.help}</small>
      )}
      {props.name && <Error name={props.name} />}
    </Wrapper>
  )
}

FormField.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string,
  help: PropTypes.string,
  helpPosition: PropTypes.string,
}

FormField.defaultProps = {
  helpPosition: "above",
}

export { FormField }
